<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import axios from "axios";

const SITES_API_URL = process.env.VUE_APP_API_URL + 'sites';

/**
 * Kanban-board component
 */
export default {
  page: {
    title: 'Site Status',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      submitting: false,
      showMessage: false,
      dismissCountDown: 0,
      filter: '',
      sites: [],
      groups: [
        {
          id: 1,
          status: 'Created',
          description: 'Site is already created in Dashboard.    ',
          nextStep: 'Site validation',
          titleColor: 'light-blue',
          items: [

          ]
        },
        {
          id: 2,
          status: 'Submitted',
          description: 'Site is submitted to the Eyeo allowlisting.',
          nextStep: `Waiting for Eyeo's review`,
          titleColor: 'beige',
          items: [

          ]
        },
        {
          id: 3,
          status: 'Whitelisted',
          description: 'Site is whitelisted.',
          nextStep: `Fill it in with IDs`,
          titleColor: 'light-green',
          items: [

          ]
        },
        {
          id: 4,
          status: 'Active',
          description: 'We are monetizing 🥳🎉',
          titleColor: 'light-pink',
          items: [

          ]
        },
      ],
      title: 'Site Status',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Site Status',
          active: true,
        },
      ],

      options: {
        dropzoneSelector: '.drag-inner-list',
        draggableSelector: '.drag-item',
        onDragend: async function(event) {
            const ownerStatusId = Number(event.owner.dataset.id);
            const targetStatusId = Number(event.droptarget.dataset.id)
            if (targetStatusId - ownerStatusId !== 1 && !this.isAdmin){
                this.dismissCountDown = 3;
                event.stop()
                
            }
            const siteId = event.nativeEvent.target.dataset.id;

            await this.handleChangeStatus(siteId, targetStatusId);

        },
      },
    }
  },
  computed: {
    isAdmin: () => {
        return JSON.parse(localStorage["auth.currentUser"]).role.name === "admin"
    },
    isMediaBuyer: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "media buyer"
    },
  },
  async mounted() {
    // Set the initial number of items
    await this.fetchSites();
  },

  methods: {
    async fetchSites() {
      const fetchSitesResponse = await axios(SITES_API_URL + '/all/grouped-by-publisher');
      this.sitesGroupedByPublisher = fetchSitesResponse.data;
      this.sitesGroupedByPublisher.map( publisherSites => {
        this.sites = [...this.sites, ...publisherSites.sites]
      })
      this.groups.map( (group, index) => {
        this.groups[index].items = this.sites.filter(site => site.status === index + 1);
      })
    },
    goToSite(id) {
        this.$router.push('/admin/sites/' + id);
    },
    async handleSubmit() {
      this.submitting = true;
      try {
      } catch (e) {
        console.log(e)
      } finally {
        this.submitting = false;
      }
    },
    async handleChangeStatus(siteId, statusId) {
        this.submitting = true;
        try {
            await axios.put(SITES_API_URL + `/${siteId}/status`, {statusId});
        } catch (e) {
            console.log(e)
        } finally {
            this.submitting = false;
      }
    },
    countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
  },

}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-sm-12 col-md-12 mb-4">
        <div id="tickets-table_filter" class="col-sm-12 col-md-12 dataTables_filter text-md-right justify-content-lg-between d-inline-flex align-items-center">
          <label class="d-inline-flex align-items-center ">
            Search:
            <b-form-input
                v-model="filter"
                type="search"
                placeholder="Search..."
                class="form-control form-control-sm ml-2"
            ></b-form-input>
          </label>
        </div>
      </div>
      <div v-drag-and-drop:options="options" class="drag-container col-sm-12 col-md-12">
        <div class="row drag-list">
          <div v-for="group in groups" :key="group.id" class="col-lg-3 drag-column">
            <div class="card-box">
              <!-- dropdown -->
              <b-dropdown right variant="white" class="float-right" toggle-class="p-0" v-if="group && group.action">
                <template slot="button-content">
                  <i class="mdi mdi-dots-vertical m-0 text-muted h3"></i>
                </template>
                <b-dropdown-item  @click="group.action.action"> {{ group.action.name }}</b-dropdown-item>
              </b-dropdown>
              <span class="drag-column-header">
                <b-badge pill :variant="group.titleColor" color="red"><p class="header-title font-weight-normal mt-1 pl-1 pr-1">{{ group.status }}</p></b-badge>
                
                <p class="sub-header mb-0 mt-2"><small class=""> {{ group.description }}</small></p>
                <p class="sub-header"><small class=""> {{ group.nextStep ? '👉 NEXT STEP: ' + group.nextStep : '' }}</small></p>
                
              </span>

              <vue-draggable-group v-model="group.items" :groups="groups" :data-id="group.id">
                <ul
                  :data-id="group.id"
                  class="sortable-list taskList list-unstyled ui-sortable drag-inner-list"
                >
                  <li
                    v-for="item in group.items.filter(x => x.domain.includes(filter))"
                    :key="item.id"
                    :data-id="item.id"
                    class="drag-item py-1 px-2"
                  >
                    <span
                      class="badge float-right"
                      :class="{
                        'bg-soft-danger text-danger': `${item.task}` === 'High',
                        'bg-soft-success text-success': `${item.task}` === 'Low',
                        'bg-soft-warning text-warning': `${item.task}` === 'Medium' }"
                    >{{ item.task}}</span>
                    <h5 class="mt-1 mb-2 site-title" v-b-tooltip="{ title: item.domain, placement: 'bottomright', variant: 'secondary' }" @click.stop="goToSite(item.id)">{{ item.domain }}</h5>
                    <b-tooltip :target="`domain-${item.id}`" variant="danger" pl>Danger variant tooltip</b-tooltip>
                    <p class="mb-1 site-subtitle" v-if="!isMediaBuyer"><i class="fe-user mr-1"></i>{{ item.mediaBuyer ? item.mediaBuyer.name + ' ' +  item.mediaBuyer.lastname : 'Not assigned' }}</p>
                    <p class="mb-1 site-subtitle"><i class="fe-box mr-1"></i>{{ item.publisher ? item.publisher : 'Not assigned' }}</p>
                    <p class="mb-0 site-subtitle"><i class="fe-map-pin mr-1"></i>{{ item.country ? item.country : 'Not assigned' }}</p>

                    <div class="clearfix"></div>
                  </li>
                </ul>
              </vue-draggable-group>

            </div>
          </div>
          <!-- end col-->
        </div>
      </div>
    </div>
    <!-- end row -->

    <div class="loader" v-if="submitting">
        <b-spinner label="Loading..."></b-spinner>
    </div>

    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="warning"
      @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownChanged"
      class="alert-message"
    >
      <span>Ask admin for help</span>
    </b-alert>
  </Layout>
</template>

<style>
.site-subtitle {
  font-size: 12px;
}
.site-title {
    display: inline-block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
    vertical-align: bottom;
}
.site-title:hover{
    cursor: pointer;
    text-decoration: underline;
}
.drag-item{
    transition: 0.5s;
}
.drag-item:hover{
    background-color: rgb(242, 242, 242);
}
.loader{
    position: fixed;
    right: 3rem;
    bottom: 1rem;
}
.alert-message{
    position: fixed;
    right: 3rem;
    bottom: 1rem;
}
</style>
